import React, { useState, useEffect } from "react";
import { Button, FlyoutFullScreen, Icon, Select } from "@accessdev/arc-ui-react";
import { languages } from "@Src/constants";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";
import { useDispatch, useSelector } from "react-redux";
import { selectors } from "@ReduxStore/reducers";
import classNames from "classnames";
import actions from "@Src/redux/rootActions";
import "./Language.scss";

const { updateLanguage } = actions.language;

export default function LanguageSelectorMobile({ classname }) {
  const [selectedLanguage, setLanguage] = useState("");
  const language = useSelector(selectors.getLanguageSelector);
  const dispatch = useDispatch();
  const [isLanguageSelectorOpen, setIsLanguageSelectorOpen] = useState(false);

  const options = Object.keys(languages).map((key) => ({
    title: languages[key],
    value: key,
  }));
  function submitLanguageChange() {
    setIsLanguageSelectorOpen(false);
    dispatch(updateLanguage({ language: selectedLanguage }));
  }

  useEffect(() => {
    setLanguage(language);
  }, [language]);

  return (
    <div
      onClick={(event) => {
        // Prevent the drop down navigation from closing
        event.stopPropagation();
      }}
      className={classNames("LanguageSelectorMobile-wrapper", classname)}
    >
      <button
        onClick={(event) => {
          setIsLanguageSelectorOpen(true);
        }}
        title={t`Select your prefered language`}
        className="LanguageSelectorMobile"
      >
        <Icon icon="language" />
        <span className="LanguageSelectorMobile-text t-label-large">{languages[language]}</span>
      </button>
      <FlyoutFullScreen
        defaultPadding={false}
        isOpen={isLanguageSelectorOpen}
        variant="LanguageSelectorMobile-Flyout"
      >
        <div className="LanguageSelectorMobile-flyoutWrapper">
          <h2 className="LanguageSelectorMobile-title t-title-large">
            <Trans>Display Settings</Trans>
          </h2>
          <Select
            label={t`Language`}
            aria-label={t`List of available languages`}
            options={options}
            selectedValue={selectedLanguage}
            onChange={(value) => setLanguage(value)}
          />
          <div className="LanguageSelectorMobile-saveRow">
            <Button
              onClick={() => submitLanguageChange()}
              className="LanguageSelectorMobile-save"
              additionalProps={{ title: t`Save language selection` }}
            >
              <Trans>Save</Trans>
            </Button>
          </div>
        </div>
      </FlyoutFullScreen>
    </div>
  );
}
